import React from 'react'
import { Link } from 'react-router-dom'
import { config } from '../pages/config'
import moment from 'moment'


const Blogs = ({ heading = "Read Our Blogs", blogs }) => {

    return (
        <div>
            <section className="news-section py-5 mt-md-5">
                <div className="auto-container">
                    <div className="sec-title centred">
                        <h2>{heading}</h2>
                    </div>
                    <div className="row clearfix">
                        {blogs?.map((blog, i) => {
                            return (
                                <div className="col-lg-4 col-md-6 col-sm-12 news-block mb-5" key={i + "45"}>
                                    <div className="news-block-one wow fadeInUp animated animated" data-wow-delay="00ms" data-wow-duration="1500ms" >
                                        <div className="inner-box">
                                            <div className="image-box">
                                                <span className="category">{blog?.type}</span>
                                                <figure className="image">
                                                    <Link to={`${config.appUrl}blog/${blog.slug}`}>
                                                        <img src={blog?.imageUrl} alt={`${blog?.name}`} />
                                                    </Link>
                                                </figure>
                                            </div>
                                            <div className="lower-content">
                                                <h4 style={{height: "80px"}}>
                                                    <Link to={`${config.appUrl}blog/${blog.slug}`}>
                                                        {blog?.name.length > 50 ? `${blog.name.slice(0, 50)}...` : blog.name}
                                                    </Link>
                                                </h4>
                                                <div className="lower-box d-flex justify-content-between">
                                                    <div>
                                                        <i className="bi bi-calendar me-2"></i><span>{moment(blog?.created_at).format("DD-MM-YYYY")}</span>
                                                    </div>
                                                    <Link to={`${config.appUrl}blog/${blog.slug}`} className='Post-Links'>
                                                        <i className='bi bi-chevron-double-right fs-5 me-4'></i> 
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Blogs
